/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateLegalEntityRequest
 */
export interface ValidateLegalEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntityRequest
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntityRequest
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntityRequest
     */
    countryCode: ValidateLegalEntityRequestCountryCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntityRequest
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateLegalEntityRequest
     */
    address?: string;
}


/**
 * @export
 */
export const ValidateLegalEntityRequestCountryCodeEnum = {
    Es: 'ES',
    Mx: 'MX',
    Ad: 'AD',
    De: 'DE',
    Pe: 'PE',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL'
} as const;
export type ValidateLegalEntityRequestCountryCodeEnum = typeof ValidateLegalEntityRequestCountryCodeEnum[keyof typeof ValidateLegalEntityRequestCountryCodeEnum];


/**
 * Check if a given object implements the ValidateLegalEntityRequest interface.
 */
export function instanceOfValidateLegalEntityRequest(value: object): value is ValidateLegalEntityRequest {
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ValidateLegalEntityRequestFromJSON(json: any): ValidateLegalEntityRequest {
    return ValidateLegalEntityRequestFromJSONTyped(json, false);
}

export function ValidateLegalEntityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateLegalEntityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taxId': json['taxId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'countryCode': json['countryCode'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'address': json['address'] == null ? undefined : json['address'],
    };
}

export function ValidateLegalEntityRequestToJSON(json: any): ValidateLegalEntityRequest {
    return ValidateLegalEntityRequestToJSONTyped(json, false);
}

export function ValidateLegalEntityRequestToJSONTyped(value?: ValidateLegalEntityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taxId': value['taxId'],
        'companyName': value['companyName'],
        'countryCode': value['countryCode'],
        'postalCode': value['postalCode'],
        'address': value['address'],
    };
}

